// eslint-disable-next-line
const arrayNext = (arr, currentIndex) => arr[++currentIndex % arr.length];

const arrayPrevious = (arr, currentIndex) =>
  // eslint-disable-next-line
  currentIndex === 0 ? arr[arr.length - 1] : arr[--currentIndex % arr.length];

export { arrayNext, arrayPrevious };
